import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface TransactionActor {
    user_id: string;
    type: TransactionActorType;
    update_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
}

export interface CreateTransactionActor {
    user_id?: string;
    type?: TransactionActorType;
}

export enum TransactionActorType {
    DROPPED_OFF_BY = 'dropped_off_by',
    PICKED_UP_BY = 'picked_up_by',
    INITIATED_BY = 'initiated_by'
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    TRANSACTION_ID = 'transaction_id',
    USER_ID = 'user_id',
    TYPE = 'type'
}

export type TransactionActorQueryParams = QueryParams & DefaultQueryParams;
export type TransactionActorListResponse = PaginatedResponse<TransactionActor>;
